// garuda - Text Glitch Component

import { useEffect } from "react";
import "./TextGlitch.css";

const TextGlitch = () => {
  useEffect(() => {
    const glitchRandomText = () => {
      // Get all text elements that are visible on screen
      const allTextElements = document.querySelectorAll(
        "h1, h2, h3, h4, h5, h6, p, span, a, button, .option-text, .activity-name, .pencil-title, .note-title",
      );

      if (allTextElements.length === 0) return;

      // Pick a random element
      const randomIndex = Math.floor(Math.random() * allTextElements.length);
      const element = allTextElements[randomIndex];

      // Skip if already glitching
      if (element.classList.contains("glitching")) return;

      // Add glitch effect
      element.classList.add("glitching");

      // Remove after animation completes
      setTimeout(() => {
        element.classList.remove("glitching");
      }, 400);
    };

    // Trigger glitch at random intervals
    const scheduleNextGlitch = () => {
      const randomDelay = Math.random() * 8000 + 3000; // 3-11 seconds
      setTimeout(() => {
        glitchRandomText();
        scheduleNextGlitch();
      }, randomDelay);
    };

    scheduleNextGlitch();

    return () => {
      // Cleanup: remove all glitch classes
      const allElements = document.querySelectorAll(".glitching");
      allElements.forEach((el) => el.classList.remove("glitching"));
    };
  }, []);

  return null; // This component doesn't render anything visible
};

export default TextGlitch;
